import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { throwError } from 'rxjs';
import { FlamingoMessageService } from './flamingo-message.service';

@Injectable()
export class FlamingoErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private ngZone: NgZone) {}

  handleError(error: any): void {
    const messageService = this.injector.get(FlamingoMessageService);

    if (error instanceof FlamingoError) {
      console.error(error.message);
      this.ngZone.run(() => messageService.showMessage('Errore: ' + error.message));
    } else {
      console.error('Errore applicazione.', error);
      throwError(error);
    }
  }
}

export class FlamingoError {
  public errorObj: HttpErrorResponse;
  public status: number;
  public message = 'Errore sconosciuto. Riprova più tardi.';
  public code: number = null;
  public attachment = null;

  constructor(error: HttpErrorResponse) {
    this.errorObj = error;
    this.status = error.status;
    try {
      this.message = error.error.message !== undefined ? error.error.message : this.message;
      this.code = error.error.errorCode !== undefined ? error.error.errorCode : this.code;
      this.attachment = error.error.attachment ? error.error.attachment : this.attachment;
    } catch (e) {}
  }
}
